export const ROOT_ROUTE = '/'
export const AUTH_ROUTE = '/login'
export const LOGOUT_ROUTE = '/logout'
export const COUNTRY_SELECTION = '/country-selection'
